// src/services/commandService.js
import api from './api';

// Get all commands
export const getAllCommands = async (filters = {}) => {
  const params = new URLSearchParams(filters);
  const response = await api.get(`/commands?${params}`);
  return response.data;
};

// Get single command
export const getCommandById = async (id) => {
  const response = await api.get(`/commands/${id}`);
  return response.data;
};

// Get commands by zone
export const getCommandsByZone = async (zone) => {
  const response = await api.get(`/commands/zone/${encodeURIComponent(zone)}`);
  return response.data;
};

// Create command
export const createCommand = async (commandData) => {
  const response = await api.post('/commands', commandData);
  return response.data;
};

// Update command
export const updateCommand = async (id, commandData) => {
  const response = await api.put(`/commands/${id}`, commandData);
  return response.data;
};

// Delete command
export const deleteCommand = async (id) => {
  const response = await api.delete(`/commands/${id}`);
  return response.data;
};